<template>
  <base-modal
    :ref="modal.key"
    :title="modal.title"
    :show="open"
    @on-confirm="save"
    @on-cancel="hide()"
    :okText="$t('Select')"
    :closeText="$t('Close')"
    :maxWidth="500"
  >
    <v-form class="mt-5">
      <v-select
        v-bind:label="$t('ContentType')"
        v-model="selected"
        :items="getSelectedContentTypes"
        item-text="text"
        item-value="id"
        :error-messages="selectedErrors"
        @input="$v.selected.$touch()"
        @blur="$v.selected.$touch()"
      ></v-select>
    </v-form>
  </base-modal>
</template>
<script>
import ContentTypeService from "@/services/ContentTypeService";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
  data() {
    return {
      contentTypeList: [],
      basketContentTypes: [],
      selected: null,
      modal: {
        title: this.$t("ContentTypes"),
        key: "contentTypeSelector",
      },
      open: false,
    };
  },
  mixins: [validationMixin],
  validations: {
    selected: { required },
  },
  computed: {
    selectedErrors() {
      const errors = [];
      if (!this.$v.selected.$dirty) return errors;
      !this.$v.selected.required && errors.push(this.$t("RequiredField"));
      return errors;
    },
    getSelectedContentTypes() {
      return this.contentTypeList.filter((c) =>
        this.basketContentTypes.includes(c.id)
      );
    },
  },
  methods: {
    save() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }
      this.$emit("on-select", this.selected);
      this.hide();
    },
    show(basketContentTypes) {
      this.basketContentTypes = basketContentTypes;
      this.loadData();
      this.$v.$reset();
      this.selected = null;
      this.open = true;
    },
    hide() {
      this.open = false;
    },
    async loadData() {
      this.contentTypeList = await ContentTypeService.getList(true, true);
    },
  },
};
</script>